<template>
<div class="tiga-notice-wrapper">
     <svg class="icon-left">
        <use xlink:href="#icon-global-notice" />
      </svg>
    <div class="notice-wrapper">
    <md-swiper
      :default-index="0"
      :dragable="false"
      :is-prevent="false"
      :has-dots="false"
      transition="slideY"
      >
      <md-swiper-item :key="$index" v-for="(item, $index) in list"  >
        <div 
          class="banner-item"
          @click="goDetail(item.id)"
          >{{item[prefix+'title']}}</div>
      </md-swiper-item>
    </md-swiper>
    </div>
    <div class="div-right" @click="goTigaNoticeList()">
      <svg class="icon-right" @click="goTigaNoticeList()">
        <use xlink:href="#icon-global-list" />
      </svg>
    </div>
</div>
</template>

<script>
import getTigaNotice from '@/api/get-tiga-notice.js';
import {Swiper, SwiperItem } from 'mand-mobile';
import { mapState } from 'vuex';

export default {
  name: 'tiga-notice',
  components: {
    [Swiper.name]: Swiper,
    [SwiperItem.name]: SwiperItem,
  },
  data() {
    return {
      list:[],
    };
  },
  computed: {
    ...mapState({
      navLang: state => state.navLang,
      tigaNotice: state=> state.tigaNotice,
      prefix(){
        if(this.navLang=='zh-cn'){
          return '';
        }
        return this.navLang+'_';
      },
    }),
  },
  mounted() {
    if(!this.tigaNotice){
      getTigaNotice()
        .then(data=>{
          this.list = data.data;
          this.$store.commit('setTigaHome', {
            tigaNotice: this.list,
          });
        });
    }
    this.list = this.tigaNotice;
  },
  methods:{
    goTigaNoticeList(){
      if(this.list.length >0){
        this.$router.push('/tigaNotice/list');
      }
    },
    goDetail(id){
      this.$router.push(`/tigaNotice/detail?id=${id}`);
    },
  },
};

</script>

<style lang="stylus" scoped>
.tiga-notice-wrapper{
  position: relative;
  padding: 0 4.8vw;
  height:9.8vw;
  display:inline-flex;
  flex-direction:row;
  align-items:center;
  justify-content: space-between;
  font-size: 3.2vw;
  .icon-left{
    height: 3.18vw;
    width: 3.18vw;
    color: color-primary;
  }
  .div-right{
     padding-left: 5vw;
     height: 100%;
     display: flex;
     align-items:center;
  }
  .icon-right{
    height: 3.88vw;
    width: 3.88vw;
    color: #2c3133;
  }
}

.notice-wrapper 
 height:100%;
 width: 75.8vw;

.banner-item
  padding: 0 1.18vw;
  width auto
  height 100%
  line-height 10.58vw
  text-align left
  font-size 3.2vw
  color #7f7f87
  align-items center
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;

a{text-decoration:none}
</style>
